import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 122,
  label: "代理机构年度申请量分析",
  chart: charts.lineAndBar2D,
  definition: {
    rowDims: [{
      name: "agencyName",
      label: "代理机构",
      limit: 10,
      needTotal: true
    }],
    colDims: [{ name: "appDate", label: "申请年", dateUnit: "YEAR", limit: 10, needTotal: true }],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true,
    condition: {
      items: [{
        name: "agencyName",
        operator: "NOT_NULL"
      }]
    }
  },
  chartOption: {
    chartType: ChartType.LINE,
    title: "代理机构年度申请量分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: true,
    hideLegend: false,
    hideToolbox: false
  }
};
